import { defineMessages } from 'react-intl';

export const messages: {
	availableOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorAnnouncement: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noResultsAnnouncement: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	availableOptions: {
		id: 'search-page.common.ui.quick-find.search-dialog-announcer.availableOptions',
		defaultMessage: '{count} options available',
		description:
			'Screen reader announcement for the number of search result options currently available in the Quick Find dialog',
	},
	errorAnnouncement: {
		id: 'search-page.common.ui.quick-find.search-dialog-announcer.errorAnnouncement',
		defaultMessage: "Something went wrong. We couldn't load your search results. Please try again.",
		description:
			'Screen reader announcement made when the Quick Find dialog fails to load search results and shows the error screen',
	},
	noResultsAnnouncement: {
		id: 'search-page.common.ui.quick-find.search-dialog-announcer.noResultsAnnouncement',
		defaultMessage: "We couldn't find any results with that title",
		description:
			'Screen reader announcement made when a Quick Find search returns no results and the no-results screen is shown',
	},
});
